// extracted by mini-css-extract-plugin
export default {"conteneur_option":"option_conteneur_option__zv-9g"};